import { transformFutureRoads } from '../../../mappers/transformFutureRoads';
import { transformTransportAccessibilityInfrastructure } from '../../../mappers/transformTransportAccessibilityInfrastructure';
import { ITAInfrastructure, TRegularInfrastructureItem } from '../../../types/map';
import { getInfrastructureItems } from './getInfrastructureItems';

export async function getAndPrepareInfrastructureItems(
  newbuildingId: number,
  infrastructureTypes: boolean,
): Promise<{
  regularInfrastructure: TRegularInfrastructureItem[];
  transportAccessibilityInfrastructure?: ITAInfrastructure;
}> {
  if (!infrastructureTypes) {
    return {
      regularInfrastructure: [],
    };
  }

  const response = await getInfrastructureItems(newbuildingId);

  const futureInfrastructure = response.futureInfrastructure || [];
  const futureRoads = transformFutureRoads(response.futureRoads);
  const transportAccessibilityInfrastructure = transformTransportAccessibilityInfrastructure(
    response.transportAccessibility,
  );

  return {
    regularInfrastructure: [...response.infrastructure, ...futureInfrastructure, ...futureRoads],
    transportAccessibilityInfrastructure,
  };
}
